import React from 'react';
import { Tooltip } from '@mui/material';
import '../ClassificationBadge/ClassificationBadge.css';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

interface SynapseBadgeProps {
    personaName?: string;
}

export const SynapseBadge: React.FC<SynapseBadgeProps> = ({ personaName }) => (
    <Tooltip title={`This answer used personalization${personaName ? ` for ${personaName}` : ''}`} placement="top">
        <div className="classification-badge badge-synapse" style={{ backgroundColor: 'var(--color-sage)', color: 'white' }}>
            <AutoStoriesIcon sx={{ fontSize: 12, marginRight: '4px' }} />
            {personaName ? `Personalized for ${personaName}` : 'Personalized'}
        </div>
    </Tooltip>
);
